<template>
  <div class="fullscreen">
    <div class="progress-dots-container">
      <div class="dots">
        <div class="dot" :class="{ filled: stage >= 0 }"></div>
        <div class="dot" :class="{ filled: stage >= 1 }"></div>
        <div class="dot" :class="{ filled: stage >= 2 }"></div>
        <div class="dot" :class="{ filled: stage >= 3 }"></div>
      </div>
    </div>
    <div class="text-box" :style="textBoxStyle">
      <div class="left-control">
        <div
          :class="{ invisible: stage == 0 }"
          class="control icon-throb"
          v-ripple
          @click.stop="prev"
        >
          <svg width="100%" height="100%" viewBox="0 0 24 24">
            <path :d="mdiChevronLeft" fill="#cdf4dd" />
          </svg>
        </div>
      </div>
      <div class="text-inner">
        {{ text[stage] }}
      </div>
      <div class="right-control">
        <div
          id="next-button"
          :class="{ invisible: stage >= text.length - 1 }"
          class="control icon-throb"
          v-ripple
          @click.stop="next"
        >
          <svg width="100%" height="100%" viewBox="0 0 24 24">
            <path :d="mdiChevronRight" fill="#cdf4dd" />
          </svg>
        </div>
      </div>
    </div>
    <div class="hole" :style="holeOneStyle"></div>
    <!--<div class="control-container" :style="controlContainerStyle">
      <div
        :class="{ invisible: stage == 0 }"
        class="control icon-throb"
        v-ripple
        @click.stop="prev"
      >
        <svg width="100%" height="100%" viewBox="0 0 24 24">
          <path :d="mdiChevronLeft" fill="#cdf4dd" />
        </svg>
      </div>
      <div
        id="next-button"
        :class="{ invisible: stage >= text.length - 1 }"
        class="control icon-throb"
        v-ripple
        @click.stop="next"
      >
        <svg width="100%" height="100%" viewBox="0 0 24 24">
          <path :d="mdiChevronRight" fill="#cdf4dd" />
        </svg>
      </div>
    </div>-->
    <div class="bottom">
      <!--<div class="text-box">
        <div class="left-control">
          <div
            :class="{ invisible: stage == 0 }"
            class="control icon-throb"
            v-ripple
            @click.stop="prev"
          >
            <svg width="100%" height="100%" viewBox="0 0 24 24">
              <path :d="mdiChevronLeft" fill="#cdf4dd" />
            </svg>
          </div>
        </div>
        <div class="text-inner">
          {{ text[stage] }}
        </div>
        <div class="right-control">
          <div
            id="next-button"
            :class="{ invisible: stage >= text.length - 1 }"
            class="control icon-throb"
            v-ripple
            @click.stop="next"
          >
            <svg width="100%" height="100%" viewBox="0 0 24 24">
              <path :d="mdiChevronRight" fill="#cdf4dd" />
            </svg>
          </div>
        </div>
      </div>-->
      <div
        class="button"
        :class="{
          throb: stage == text.length - 1,
          invisible: stage != text.length - 1,
        }"
        @click="finalButtonClick"
        v-ripple
      >
        Got it!
      </div>
    </div>
  </div>
</template>

<script>
import { mdiChevronLeft, mdiChevronRight } from '@mdi/js'
import { scrollTo } from '@/lib/simple_scroller.js'
import gsap from 'gsap'

export default {
  name: 'TutorialSidePanel',
  data() {
    return {
      mdiChevronLeft,
      mdiChevronRight,
      offset: 10,
      stage: 0,
      laggedStage: 0,
      text: [
        'Here you will see all the secrets that are out there to be discovered.',
        "Select the ones you've discovered for a reminder of how to trigger them.",
        "Select an undiscovered secret to get a hint. If you're stuck, you can also spend credits to reveal it.",
        'Discover all the secrets to move to the next level.',
      ],
      buttonText: ['Gotcha'],
      timeline: undefined,
      unlockedExample: '',
      lockedExample: '',
      positions: {},
    }
  },
  /*props: {
    positions: Object,
  },*/
  mounted() {
    if (this.$store.getters.unlockedActions.includes('slingshot')) {
      this.unlockedExample = 'slingshot'
    } else {
      this.unlockedExample = this.$store.getters.unlockedActions[0]
    }

    const lockedKeys = Object.keys(this.$store.getters.actions).filter(
      (x) => !this.$store.getters.unlockedActions.includes(x)
    )
    if (lockedKeys.length >= 1) {
      this.lockedExample = lockedKeys[0]
    } else {
      this.lockedExample = this.unlockedExample
    }

    this.$nextTick(() => {
      scrollTo('panel-content-container', this.unlockedExample).then(() => {
        this.updatePanelPositions()
      })
    })
  },
  computed: {
    /*controlContainerStyle() {
      const offset = this.convertRemToPixels(1)
      if (this.positions['code-container'] === undefined) {
        return {}
      } else {
        return {
          position: 'absolute',
          top: this.positions['code-container'].y - offset + 'px',
          height: this.positions['code-container'].height + 2 * offset + 'px',
        }
      }
    },*/
    holeOneStyle() {
      const undefinedStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        height: '0px',
        width: '0px',
      }
      let offset = this.convertRemToPixels(1)
      switch (this.laggedStage) {
        case 0:
          offset = this.convertRemToPixels(1)
          if (this.positions[this.unlockedExample] === undefined) {
            return undefinedStyle
          } else {
            return {
              position: 'absolute',
              top: this.positions[this.unlockedExample].y + offset + 'px',
              left: this.positions[this.unlockedExample].x + offset / 2 + 'px',
              width: this.positions[this.unlockedExample].width - offset + 'px',
              height: `calc(100% - ${
                this.positions[this.unlockedExample].y + offset
              }px)`,
            }
          }
        case 1:
          offset = this.convertRemToPixels(1)
          if (this.positions[this.unlockedExample] === undefined) {
            return undefinedStyle
          } else {
            return {
              position: 'absolute',
              top: this.positions[this.unlockedExample].y + offset + 'px',
              left: this.positions[this.unlockedExample].x + offset / 2 + 'px',
              width: this.positions[this.unlockedExample].width - offset + 'px',
              height: this.positions[this.unlockedExample].height + 'px',
            }
          }
        case 2:
          offset = this.convertRemToPixels(1)
          if (this.positions[this.lockedExample] === undefined) {
            return undefinedStyle
          } else {
            return {
              position: 'absolute',
              top: this.positions[this.lockedExample].y + offset + 'px',
              left: this.positions[this.lockedExample].x + offset / 2 + 'px',
              width: this.positions[this.lockedExample].width - offset + 'px',
              height: this.positions[this.lockedExample].height + 'px',
            }
          }
        case 3:
          offset = this.convertRemToPixels(1)
          if (this.positions['number-container'] === undefined) {
            return undefinedStyle
          } else {
            return {
              position: 'absolute',
              top: this.positions['number-container'].y - offset / 2 + 'px',
              left: this.positions['number-container'].x - offset / 2 + 'px',
              width: this.positions['number-container'].width + offset + 'px',
              height: this.positions['number-container'].height + offset + 'px',
            }
          }
        default:
          return undefinedStyle
      }
    },
    textBoxStyle() {
      let offset
      switch (this.laggedStage) {
        case 0:
        case 1:
        case 2:
          offset = this.convertRemToPixels(1)
          return {
            position: 'absolute',
            bottom: `calc(100% - ${this.holeOneStyle.top} + ${offset}px)`,
          }
        /*if (this.positions['side-panel-header'] === undefined) {
            return {}
          } else {
            return {
              position: 'absolute',
              top: '1rem',
              bottom: `calc(100% - ${
                this.positions['side-panel-header'].y +
                this.positions['side-panel-header'].height
              }px`,
            }
          }*/
        case 3:
          offset = this.convertRemToPixels(1)
          return {
            position: 'absolute',
            top: `calc(${this.holeOneStyle.top} + ${this.holeOneStyle.height} + ${offset}px)`,
          }
        /*if (this.positions['side-panel-header'] === undefined) {
            return {}
          } else {
            return {
              position: 'absolute',
              top:
                this.positions['side-panel-header'].y +
                this.positions['side-panel-header'].height +
                'px',
            }
          }*/

        default:
          return {}
      }
    },
  },
  methods: {
    updatePanelPositions() {
      //debugger
      let positions = {}
      Object.keys(this.$store.getters.actions).forEach((k) => {
        positions[k] = document.getElementById(k).getBoundingClientRect()
      })

      let elem = document.getElementById('side-panel-header')
      if (!(elem === null)) {
        positions['side-panel-header'] = elem.getBoundingClientRect()
      }

      elem = document.getElementById('number-container')
      if (!(elem === null)) {
        positions['number-container'] = elem.getBoundingClientRect()
      }

      this.positions = positions
    },
    next() {
      console.log('next')
      this.fadeTextOutIn(() => {
        this.stage += 1
      })
    },
    prev() {
      console.log('prev')
      this.fadeTextOutIn(() => {
        this.stage -= 1
      })
    },
    fadeTextOutIn(onComplete) {
      const tl = gsap.timeline({ repeat: 0 })

      tl.to(['.text-inner', '.right-control', '.left-control'], {
        opacity: 0,
        duration: 0.4,
        onComplete,
      })
      tl.to(['.text-inner', '.right-control', '.left-control'], {
        opacity: 1,
        duration: 0.4,
      })
    },
    convertRemToPixels(rem) {
      return (
        rem * parseFloat(getComputedStyle(document.documentElement).fontSize)
      )
    },
    finalButtonClick() {
      this.$store.commit('SET_LIBRARY_TUTORIAL_SEEN', true)
      this.$emit('close')
    },
  },
  watch: {
    stage(new_val) {
      if (new_val == 0) {
        scrollTo('panel-content-container', this.unlockedExample).then(() => {
          this.updatePanelPositions()
          this.laggedStage = new_val
        })
      } else if (new_val == 1) {
        scrollTo('panel-content-container', this.unlockedExample).then(() => {
          this.updatePanelPositions()
          this.laggedStage = new_val
        })
      } else if (new_val == 2) {
        scrollTo('panel-content-container', this.lockedExample).then(() => {
          this.updatePanelPositions()
          this.laggedStage = new_val
        })
      } else if (new_val == 3) {
        this.laggedStage = new_val
      }
    },
  },
}
</script>

<style scoped>
.fullscreen {
  position: absolute;
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  height: 100%;
  width: 100%;
  background: transparent;
  z-index: 999;
}

.button {
  display: block;
  max-width: 20rem;
  padding: 1em;
  text-align: center;
  border: 1px solid #cdf4dd;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.5s ease, color 0.5s ease;
  color: #cdf4dd;
  font-family: 'Montserrat', sans-serif;
}

.hole {
  border-radius: 10px;
  box-shadow: 0 0 0 99999px rgba(0, 0, 0, 0.85);
  transition: width 0.5s, height 0.5s, top 0.5s, bottom 0.5s, left 0.5s,
    right 0.5s;
}

.text-box {
  /*width: calc(100% - 4rem);*/
  width: 100%;
  max-width: 30rem;
  color: #cdf4dd;
  font-family: 'Montserrat', sans-serif;
  z-index: 98;
  text-align: center;
  padding-bottom: 1rem;
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  margin-top: 1rem;
  /*outline: 1px solid red;*/
}

.left-control,
.right-control {
  flex-grow: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}

.text-inner {
  flex-grow: 1;
  padding-left: 1rem;
  padding-right: 1rem;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}

.control-container {
  /*width: calc(100% - 4rem);
  max-width: 30rem;*/
  width: 100%;
  max-width: 30rem;
  /*outline: 1px solid green;*/
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  /*padding-left: 1rem;
  padding-right: 1rem;*/
  box-sizing: border-box;
}

.control {
  color: #cdf4dd;
  font-family: 'Montserrat', sans-serif;
  border-radius: 50%;
  width: 3rem;
  height: 3rem;
  cursor: pointer;
}

.invisible {
  visibility: hidden;
}

.bottom {
  position: absolute;
  bottom: 2rem;
  max-width: 20rem;
  width: calc(100% - 4rem);
  display: flex;
  flex-direction: column;
}

.bottom > * + * {
  margin-top: 1rem;
}

@media (hover: hover) {
  .button:hover {
    background-color: rgba(204, 244, 221, 0.1);
  }
}

.button.throb {
  animation-name: button-throb-animation;
  animation-duration: 0.75s;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  transform-origin: center;
}

@keyframes button-throb-animation {
  from {
    background-color: transparent;
  }
  to {
    background-color: rgba(224, 168, 0, 0.3);
  }
}

.icon-throb path {
  animation-name: icon-throb-animation;
  animation-duration: 0.5s;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  transform-origin: center;
}

@keyframes icon-throb-animation {
  from {
    /*fill: #cdf4dd;*/
    transform: scale(1);
  }
  to {
    /*fill: #e0a800;*/
    transform: scale(1.2);
  }
}

.progress-dots-container {
  height: 2rem;
  width: 100%;
  color: #cdf4dd;
  font-family: 'Montserrat', sans-serif;
  position: absolute;
  top: 0.5rem;
  z-index: 98;
}

.dots {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.dots > * + * {
  margin-left: 0.5rem;
}

.dot {
  border-radius: 50%;
  height: 0.7rem;
  width: 0.7rem;
  border: 1px solid #cdf4dd;
}

.filled {
  background-color: #cdf4dd;
}
</style>
